/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
import _isObject from 'lodash/isObject';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _isFunction from 'lodash/isFunction';
import _eq from 'lodash/eq';
import _set from 'lodash/set';
import _cloneDeep from 'lodash/cloneDeep';
import _assign from 'lodash/assign';
import _isString from 'lodash/isString';
import _merge from 'lodash/merge';
import { __awaiter, __generator, __decorate } from 'tslib';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { filter, concatMap, of } from 'rxjs';
import { AjaxBasics } from '../helpers';
import { BaseModel } from './baseModel';
import { EnumActionKeys, EnumBasesKeys, BasesOptions } from './basesOptions';
import { BasesUtils } from './basesUtils';

/**
 * 基础 数据详情
 */

var BasesDetails =
/** @class */
function () {
  /**
   * 基础 数据详情
   * @param {IBasesDetailsOptions} [options={}]
   * @memberof BasesDetails
   */
  function BasesDetails(options) {
    if (options === void 0) {
      options = {};
    }
    /**
     * 默认配置
     * @type {IBasesDetailsOptions}
     * @memberof BasesDetails
     */


    this.defaultOptions = {
      dataKey: BasesOptions.dataKey,
      details: BasesOptions.details,
      detailsParams: {}
    };
    /**
     * 配置
     * @type {IBasesDetailsOptions}
     * @memberof BasesDetails
     */

    this.options = {};
    this.Model = new BaseModel(_merge({
      type: "object"
    }, options === null || options === void 0 ? void 0 : options.entityModel));
    this.reset(options);
  }

  Object.defineProperty(BasesDetails.prototype, "entity", {
    /**
     * 详情数据
     * @readonly
     * @memberof [Model.value]
     */
    get: function get() {
      return this.Model.value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesDetails.prototype, "AjaxConfig", {
    /**
     * AjaxConfig
     * @readonly
     * @memberof lodash.assign(basesOptions.details,this.options.details)
     */
    get: function get() {
      var details = this.options.details;

      if (_isString(details)) {
        details = {
          url: this.options.details
        };
      }

      return _assign({
        target: this.options.target
      }, BasesOptions.details, details);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesDetails.prototype, "detailsParams", {
    /**
    * details 参数配置
    * @readonly
    * @memberof lodash.assign(...)
    */
    get: function get() {
      return _merge({}, this.defaultOptions.detailsParams, this.options.detailsParams);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesDetails.prototype, "timestamp", {
    /**
     * 当前请求的 生成时间戳
     * @readonly
     * @memberof [Model.getStorage(timestamp])]
     */
    get: function get() {
      return this.Model.getStorage(EnumBasesKeys.timestamp);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesDetails.prototype, "requestError", {
    /**
    * 请求出错
    * @readonly
    * @memberof BasesPagination
    */
    get: function get() {
      return this.Model.getStorage(EnumBasesKeys.requestError, false);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesDetails.prototype, "loading", {
    /**
     * 当前请求的 加载状态
     * @readonly
     * @memberof [Model.loading)]
     */
    get: function get() {
      return this.Model.loading;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 重置 配置
   * @param options
   */

  BasesDetails.prototype.reset = function (options) {
    if (options === void 0) {
      options = _cloneDeep(this.options);
    } // if (this.loading) {
    //     return BasesUtils.warning(`Details reset loading 未完成`);
    // }


    _assign(this.options, this.defaultOptions, options);

    this.clear();
    return this;
  };
  /**
   * 加载数据
   * @param {(string | { [key: string]: any })} body
   * @param {IAjaxConfig} [AjaxConfig]
   * @default body:string > { [this.options.dataKey]: body }
   */

  BasesDetails.prototype.onLoad = function (body, AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      var timestamp_1, obs, response, error_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            timestamp_1 = Date.now();
            this.Model.toggleLoading(true);
            this.Model.setStorage(EnumBasesKeys.timestamp, timestamp_1);
            AjaxConfig = this.createAjaxConfig(body, AjaxConfig);

            _set(AjaxConfig, 'headers.timestamp', timestamp_1);

            BasesUtils.log("Details onLoad " + timestamp_1, AjaxConfig);
            obs = AjaxBasics.requestObservable(AjaxConfig).pipe( // 过滤过期请求
            filter(function () {
              if (_eq(timestamp_1, _this.timestamp)) {
                return true;
              }

              BasesUtils.warning(EnumActionKeys.details + (" " + timestamp_1 + " \u8FC7\u671F > " + _this.timestamp + " \u6700\u65B0 "));
            }), concatMap(function (response) {
              var _a = _this.detailsParams,
                  valueGetter = _a.valueGetter,
                  dataSource = _a.dataSource;

              if (_isFunction(valueGetter)) {
                var res = valueGetter(response, AjaxConfig);

                if (res instanceof Promise) {
                  return res;
                }

                return of(res);
              }

              if (_isString(dataSource) && _has(response, dataSource)) {
                return of(_get(response, dataSource));
              }

              return of(response);
            }));
            return [4
            /*yield*/
            , AjaxBasics.toPromise(obs, AjaxConfig)];

          case 1:
            response = _a.sent();
            this.set(response);
            return [2
            /*return*/
            , response];

          case 2:
            error_1 = _a.sent();
            BasesUtils.error(EnumActionKeys.details, error_1, this);
            this.Model.setStorage(EnumBasesKeys.requestError, true);
            this.Model.toggleLoading(false);
            throw error_1;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 设置 response 数据
   * @param {*} response
   * @memberof BasesDetails
   */


  BasesDetails.prototype.set = function (response) {
    if (response) {
      BasesUtils.log("Details Set " + this.timestamp, response, this);
      this.Model.setStorage(EnumBasesKeys.response, response);
      this.Model.set(response);
    }

    this.Model.toggleLoading(false);
    return response;
  };
  /**
   * 清理数据
   */


  BasesDetails.prototype.clear = function () {
    this.Model.set({});
    this.Model.clearStorage();
  };
  /**
   * 创建 onLoad AjaxConfig
   * @param AjaxConfig
   * @returns
   */


  BasesDetails.prototype.createAjaxConfig = function (body, AjaxConfig) {
    var _a;

    if (!_isObject(body)) {
      body = (_a = {}, _a[this.options.dataKey] = body, _a);
    }

    AjaxConfig = _merge({}, {
      body: body
    }, this.AjaxConfig, AjaxConfig);
    this.Model.setStorage(EnumBasesKeys.request, _cloneDeep(AjaxConfig));
    return AjaxConfig;
  };

  __decorate([computed], BasesDetails.prototype, "entity", null);

  __decorate([computed], BasesDetails.prototype, "timestamp", null);

  __decorate([computed], BasesDetails.prototype, "requestError", null);

  __decorate([computed], BasesDetails.prototype, "loading", null);

  BasesDetails = __decorate([BindAll()], BasesDetails);
  return BasesDetails;
}();

export { BasesDetails };
//# sourceMappingURL=basesDetails.js.map
